<template>
    <div class="wrapper m-lg-3 p-lg-4 d-flex flex-column">
        <div class="controls flex-shrink-0 d-lg-none">
            <button v-on:click="onBack" class="btn btn-secondary">{{ $t('events.back') }}</button>
        </div>
        <form v-if="!!mutableEvent" class="flex-shrink-0" :class="{ 'was-validated': validated }" v-on:submit.prevent="onSave" novalidate>
            <div class="form-group row">
                <label for="event-title" class="col-sm-2 col-form-label col-form-label-lg d-">{{ $t('events.title') }}</label>
                <div class="col-sm-8">
                    <input type="text" ref="title" class="form-control form-control-lg" :disabled="!editmode" id="event-title" :placeholder="$t('events.title')" required v-model="mutableEvent.title">
                </div>
            </div>
            <div class="form-group row">
                <label for="event-date" class="col-sm-2 col-form-label">{{ $t('events.date') }}</label>
                <div class="col-sm-8 col-6">
                    <input type="date" class="form-control" id="event-title" :disabled="!editmode" :placeholder="$t('events.date')" required v-model="date">
                </div>
                <span v-if="total > 0" class="col-form-label col-sm-2 col-6 counter">{{ count }} / {{ total }}</span>
            </div>
            <div v-if="!!mutableEvent" class="event-controls text-right flex-shrink-0">
                <b-form-input v-model="query" type="text" :placeholder="$t('events.search')"></b-form-input>
                <a v-if="!editmode" v-on:click.prevent="onEdit" href="#" class="btn btn-link text-secondary">{{ $t('events.edit') }}</a>
                <a v-if="editmode" v-on:click.prevent="onCancel" href="#" class="btn btn-link text-secondary">{{ $t('events.cancel') }}</a>
                <a v-if="editmode && mutableEvent._id" v-on:click.prevent="onDelete" href="#" class="btn btn-link text-danger">{{ $t('events.delete') }}</a>
                <button v-if="editmode" type="submit" class="btn btn-link text-primary">{{ $t('events.save') }}</button>
            </div>
        </form>
        <AttendeeList v-if="!!mutableEvent" ></AttendeeList>
        <AttendeeActions v-if="!!mutableEvent && !!mutableEvent._id"></AttendeeActions>
        <span v-if="!mutableEvent">{{ $t('events.nothingselected') }}</span>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import AttendeeList from './AttendeeList.vue';
import AttendeeActions from './AttendeeActions.vue';

export default {
    name: 'event',
    data() {
        return {
            validated: false,
            edit: false,
        };
    },
    computed: {
        date: {
            get() {
                if (!this.mutableEvent || !this.mutableEvent.date) return '';
                return DateTime.fromISO(this.mutableEvent.date).toISODate();
            },
            set(val) {
                if (!this.mutableEvent) return;
                this.mutableEvent.date = DateTime.fromISO(val).toISODate();
            },
        },
        query: {
            get() {
                return this.$store.state.query;
            },
            set(val) {
                this.$store.commit('searchAttendees', val);
            }
        },
        editmode() {
            var mode = this.$route.query.mode;
            return mode === 'edit' || mode === 'new';
        },
        mutableEvent: {
            get() {
                const id = this.$route.query.id;
                const event = this.$store.state.events.list.find(ev => ev._id === id);
                if (event) return this.clone(event);
                if (this.editmode) return {};
            },
            set() { /* ignore */ },
        },
        count() {
            if (!this.mutableEvent) return 0;
            return this.mutableEvent.attendees.reduce((memo, attendee) => {
                if (attendee.status === 'attending') return memo + 1;
                return memo;
            }, 0);
        },
        total() {
            if (!this.mutableEvent) return 0;
            if (!this.mutableEvent.attendees) return 0;
            return this.mutableEvent.attendees.length;
        }
    },
    methods: {
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        onEdit() {
            this.$router.push({ path: 'events', query: { id: this.mutableEvent._id, mode: 'edit' } });
            setTimeout(() => this.$refs.title.focus() );
        },
        onCancel() {
            if (!this.mutableEvent._id) return this.$router.push({ path: 'events' });
            this.$router.push({ path: 'events', query: { id: this.mutableEvent._id } });
        },
        onDelete() {
            this.$store.dispatch('deleteEvent', this.mutableEvent);
            this.$router.push({ path: 'events' });
        },
        async onSave(ev) {
            if (ev.target.checkValidity() === false) return this.validated = true;
            this.validated = false;
            const data = this.clone(this.mutableEvent);
            const res = await this.$store.dispatch('saveEvent', data);
            this.$router.push({ path: 'events', query: { id: res.body._id }});
        },
        onBack() {
            this.$router.push({ path: 'events' });
        },
    },
    components: {
        AttendeeList,
        AttendeeActions,
    },
};
</script>

<style lang="scss">
    .eventdetail {
        .form-control:disabled {
            background: transparent;
            border-color: transparent;
        }

        .wrapper {
            background-color: #fff;
            border-radius: 5px;
            border: 1px solid #888;
            max-height: calc(100% - 2rem);
            overflow: hidden;
        }

        .counter {
            text-align: right;
        }

        .event-controls {
            input {
                max-width: 200px;
                float: left;
            }
        }

        @media (max-width: 575px) {
            label {
                display: none;
            }
            .form-group {
                margin-bottom: 2px;
            }
        }

        @media (max-width: 991px) {
            .wrapper {
                height: calc(100% - 2px);
                max-height: calc(100% - 2px);
                padding: 13px;
                margin: 3px;
            }
        }
    }
</style>